<template>
  <nav class="school-navbar">
    <div class="nav-container">
      <div class="hstack gap-3 text-white me-auto" data-v-step="2">
        <figure class="logo d-none d-sm-flex align-items-center m-0 me-3" alt="PTC Wizard Logo">
          <Logo class="h-100" />
        </figure>
      </div>

      <div class="nav-right">
        <div style="width: 150px"></div>
        <button class="help fs-6" @click="tour?.start?.()">
          <i class="bi fs-5 bi-question-circle"></i>
          <span class="d-none d-sm-block">Help</span>
        </button>
        <div class="dropdown" data-cy="nav-select">
          <button
            class="btn text-white dropdown-toggle text-capitalize fs-normal px-2"
            type="button"
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i class="bi bi-person-fill fs-4 me-n1 d-md-none"></i>
            <span class="d-none d-md-inline-block align-middle">
              Support Agent              
            </span>
          </button>
          <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton1">
            <li style="cursor: pointer">
              <RouterLink
                style="text-decoration: none; color: unset"
                :to="{ name: 'support-accounts' }"
                data-cy="nav-account-settings-btn"
              >
                <span class="dropdown-item" @click="authenticationStore.modal = true"
                  >Account Settings</span
                >
              </RouterLink>
            </li>
            <li style="cursor: pointer">
              <span class="dropdown-item" @click="logout()">Log Out</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>

  
</template>
<script lang="ts" setup>
import { ref } from "vue";

import { useAuthenticationStore } from "@/stores/authentication";
import Logo from "@/assets/icons/logo-vertical-knockout.svg";

// defineProps<{}>();
// defineEmits();

const authenticationStore = useAuthenticationStore();

const tour = ref<any>(null);

function logout() {
  authenticationStore.logout();
  window.location.pathname = "/support/login";
}
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;

.school-navbar {
  padding: 10px 15px;
  display: flex;
  background: linear-gradient(#4c1216, #721a1e 20%, #4b1216);

  .nav-container {
    display: flex;
    justify-content: space-between;
    width: 100%;

    .select-event {
      height: fit-content;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      flex-direction: column;
      button {
        margin: 0;
        padding: 0;
      }
    }

    .nav-right {
      display: flex;
      align-items: center;
      gap: 20px;

      :deep(.v-select__selection-text) {
        color: white;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .help {
        display: flex;
        align-items: center;
        gap: 7px;
        color: white;
        padding: 5px 10px;
        border-radius: 4px;
        transition: background-color 0.2s linear;

        &:hover {
          background-color: rgba(0, 0, 0, 0.134);
        }
        &:active {
          background-color: rgba(0, 0, 0, 0.234);
        }
      }
    }
  }
}
</style>
